import {
  ROUTE_ABOUT_AND_CONTACT,
  ROUTE_BUY_POINT,
  ROUTE_CLUE_TEN_STEP,
  ROUTE_CLUES,
  ROUTE_MARKET_PLACE,
  ROUTE_MY_PLACE_TREASURE,
  ROUTE_PLACE_AR_TREASURE,
  ROUTE_PROFILE,
  ROUTE_PROFILE_REFERRAL,
  ROUTE_SWAP_POINT,
  ROUTE_TRANSACTION_MANAGEMENT,
  ROUTE_PLACE_GOLD,
  ROUTE_PLACE_PHYSICAL_QR_CODE,
  ROUTE_IGC_CRYPTO_PAGE,
  ROUTE_WISH_LIST,
  ROUTE_MERCHANDISE,
} from '../state/modules/routing';
import { fullPublicUrl } from '../utils/helper';
export const GOOGLE_MAP_API_KEY = process.env.REACT_APP_GOOGLE_MAP_API_KEY;
export const isProd = process.env.REACT_APP_ENVIRONMENT === 'production';

export const menuSidebar = [
  {
    name: 'Swap Points',
    path: ROUTE_SWAP_POINT,
    image: '/images/sidebar/ic-swap.svg',
    imageActive: '/images/sidebar/ic-swap-active.svg',
    isComingSoon: false,
  },
  {
    name: 'Buy Points For Hunt',
    path: ROUTE_BUY_POINT,
    image: '/images/sidebar/ic-buy-coin.svg',
    imageActive: '/images/sidebar/ic-buy-coin-active.svg',
    isComingSoon: false,
  },
  {
    name: 'Loyalty Marketplace',
    path: ROUTE_MARKET_PLACE,
    image: '/images/sidebar/ic-loyalty.svg',
    imageActive: '/images/sidebar/ic-loyalty-active.svg',
    isComingSoon: false,
  },
  {
    name: 'Place AR Treasure',
    path: ROUTE_PLACE_AR_TREASURE,
    image: '/images/sidebar/ic-place-treasure.svg',
    imageActive: '/images/sidebar/ic-place-treasure-active.svg',
    isComingSoon: false,
  },
  {
    name: 'Place Gold Bar (Soon)',
    path: ROUTE_PLACE_GOLD,
    image: '/images/sidebar/ic-place-gold.svg',
    imageActive: '/images/sidebar/ic-place-gold-active.svg',
    isComingSoon: true,
  },
  {
    name: 'Create QR Code for Hunt',
    path: ROUTE_PLACE_PHYSICAL_QR_CODE,
    image: '/images/sidebar/ic-create-qr.svg',
    imageActive: '/images/sidebar/ic-create-qr-active.svg',
    isComingSoon: false,
  },
  {
    name: 'Clues Page',
    path: ROUTE_CLUES,
    image: '/images/sidebar/ic-clues-page.svg',
    imageActive: '/images/sidebar/ic-clues-page-active.svg',
    isComingSoon: false,
  },
  {
    name: 'Ten Step Hunt',
    path: ROUTE_CLUE_TEN_STEP,
    image: '/images/sidebar/ic-clues-page.svg',
    imageActive: '/images/sidebar/ic-clues-page-active.svg',
    isComingSoon: false,
  },
  {
    name: 'Transactions',
    path: ROUTE_TRANSACTION_MANAGEMENT,
    image: '/images/sidebar/ic-transaction.svg',
    imageActive: '/images/sidebar/ic-transaction-active.svg',
    isComingSoon: false,
  },
  {
    name: 'My Placed Treasures',
    path: ROUTE_MY_PLACE_TREASURE,
    image: '/images/sidebar/ic-my-place-treasures.svg',
    imageActive: '/images/sidebar/ic-my-place-treasures-active.svg',
    isComingSoon: false,
  },
  {
    name: 'Leaderboard',
    path: '/profile#leaderboard',
    image: '/images/sidebar/ic-leaderboard.svg',
    imageActive: '/images/sidebar/ic-leaderboard-active.svg',
    isComingSoon: false,
  },
  {
    name: 'Make Own AR (Soon)',
    path: '/',
    image: '/images/sidebar/ic-make-own.svg',
    imageActive: '/images/sidebar/ic-swap-active.svg',
    isComingSoon: true,
  },
  {
    name: 'Wish lists',
    path: ROUTE_WISH_LIST,
    image: '/images/sidebar/ic-wish-list.svg',
    imageActive: '/images/sidebar/ic-wish-list-active.svg',
    isComingSoon: false,
  },
  {
    name: 'Settings (Soon)',
    path: '/',
    image: '/images/sidebar/ic-setting.svg',
    imageActive: '/images/sidebar/ic-setting-active.svg',
    isComingSoon: true,
  },
  {
    name: 'Profiles',
    path: ROUTE_PROFILE,
    image: '/images/sidebar/ic-profile.svg',
    imageActive: '/images/sidebar/ic-profile-active.svg',
    isComingSoon: false,
  },
  {
    name: 'All Apps (Soon)',
    path: '/',
    image: '/images/sidebar/ic-all-app.svg',
    imageActive: '/images/sidebar/ic-all-app-active.svg',
    isComingSoon: true,
  },
  {
    name: 'IGC Crypto Page',
    path:  ROUTE_IGC_CRYPTO_PAGE,
    image: '/images/logo_new.png',
    imageActive: '/images/logo_new.png',
    isComingSoon: false,
  },
  {
    name: 'Debit Cards (Soon)',
    path: '/',
    image: '/images/sidebar/ic-debit-card.svg',
    imageActive: '/images/sidebar/ic-debit-card-active.svg',
    isComingSoon: true,
  },
  {
    name: 'Buy Merchandise',
    path: ROUTE_MERCHANDISE,
    image: '/images/sidebar/ic-buy-merchandise.svg',
    imageActive: '/images/sidebar/ic-buy-merchandise-active.svg',
    isComingSoon: false,
  },
  {
    name: 'About / Contact',
    path:  ROUTE_ABOUT_AND_CONTACT,
    image: '/images/sidebar/ic-about-contact.svg',
    imageActive: '/images/sidebar/ic-about-contact-active.svg',
    isComingSoon: false,
  },
  {
    name: 'Logout',
    path: '/',
    image: '/images/sidebar/ic-logout.svg',
    imageActive: '/images/sidebar/ic-logout-active.svg',
    isComingSoon: false,
  },
].map(item => {
  item.image = fullPublicUrl(item.image);
  item.imageActive = fullPublicUrl(item.imageActive);
  return item;
});

export const featureMenu = [
  {
    title: 'Swap',
    image: '/images/sidebar/ic-swap.svg',
    path: ROUTE_SWAP_POINT,
  },
  {
    title: 'Buy Points For Hunt',
    image: '/images/sidebar/ic-buy-coin.svg',
    path: ROUTE_BUY_POINT,
  },
  {
    title: 'Loyalty',
    image: '/images/sidebar/ic-loyalty.svg',
    path: ROUTE_MARKET_PLACE,
  },
  {
    title: 'Gold Bars',
    image: '/images/sidebar/ic-place-gold.svg',
    path: ROUTE_PLACE_GOLD,
  },
  {
    title: 'Profile',
    image: '/images/sidebar/ic-profile.svg',
    path: ROUTE_PROFILE,
  },
  {
    title: 'Leaderboard',
    image: '/images/sidebar/ic-leaderboard.svg',
    path: '/profile#leaderboard',
  },
  {
    title: 'QR Code',
    image: '/images/sidebar/ic-create-qr.svg',
    path: ROUTE_PLACE_PHYSICAL_QR_CODE,
  },
  {
    title: 'Clues',
    image: '/images/sidebar/ic-clues-page.svg',
    path: ROUTE_CLUES,
  },
];

export const featureGrid = [
  {
    title: 'Refer Friend for Points',
    image: '/images/ic-folder.svg',
    path: ROUTE_PROFILE_REFERRAL,
  },
  {
    title: 'Check Out the Loyalty Points',
    image: '/images/ic-heart.svg',
    path: ROUTE_MARKET_PLACE,
  },
  {
    title: 'Place a real IGC Marker in Hunt',
    image: '/images/logo_new.png',
    path: ROUTE_PLACE_PHYSICAL_QR_CODE,
  },
  {
    title: 'Run My Own Hunt',
    className: 'max-w-[150px]',
    image: '/images/ic-runway.svg',
    path: ROUTE_PLACE_AR_TREASURE,
  },
  {
    title: 'Create My Wishlist',
    image: '/images/ic-wishlist.svg',
    path: null,
  },
  {
    title: 'Swap Some Points',
    className: 'max-w-[180px]',
    image: '/images/ic-points.svg',
    path: ROUTE_SWAP_POINT,
  },
  {
    title: 'Create AR Logo for Hunt',
    className: 'max-w-[180px]',
    image: '/images/ic-ArIcon.svg',
    path: ROUTE_PLACE_AR_TREASURE,
  },
  {
    title: 'Buy some Points to put into Hunt',
    image: '/images/ic-buypints.svg',
    path: ROUTE_BUY_POINT,
  },
].map(item => {
  item.image = fullPublicUrl(item.image);
  return item;
});
